import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import PdfReader from "./Reader/PdfReader";
import EpubReader from "./Reader/EpubReader";
import { getDocument } from "../../pages/SearchPage/SearchPageApi";
import "./Reader.scss";

const supportedFormats = ["pdf", "epub", "mobi"];

const Reader = ({ id, height }) => {
    const [file, setFile] = useState(null);
    const [extension, setExtension] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        getDocument(
            id,
            (res) => {
                setFile(res.file);
                setExtension(res.extension);
                setLoading(false);
            },
            () => setLoading(false)
        );
    }, [id]);

    const renderReader = () => {
        if (!extension || !supportedFormats.includes(extension)) {
            return (
                <Box className="reader-error">
                    <Typography variant="h5" gutterBottom>
                        Nie można otworzyć dokumentu o rozszerzeniu '{extension || "null"}'
                    </Typography>
                    <Typography variant="body1">Wspierane typy dokumentów to: pdf, epub, mobi</Typography>
                    <Typography variant="body2" sx={{ mt: 2 }}>Proszę pobrać dokument i otworzyć go w odpowiednim programie.</Typography>
                    <Box mt={2}>
                        <Typography variant="body2">Dokument ID: {id}</Typography>
                        <Typography variant="body2">Rozszerzenie: {extension}</Typography>
                        <Typography variant="body2">Wersja: {window.version}</Typography>
                        <Typography variant="body2">Data: {new Date().toLocaleDateString()}</Typography>
                        <Typography variant="body2">Godzina: {new Date().toLocaleTimeString()}</Typography>
                    </Box>
                </Box>
            );
        }

        const readerProps = { file, height, loading };

        if (extension === "pdf") return <PdfReader {...readerProps} />;
        return <EpubReader {...readerProps} />; // handles both 'epub' and 'mobi'
    };

    return (
        <Box className="reader-container">
            {loading ? (
                <Box className="loading-cover">
                    <CircularProgress />
                </Box>
            ) : (
                renderReader()
            )}
        </Box>
    );
};

export default Reader;
